<template>
	<div class="flex gap-4">
		<div class="progress-circle__container">
			<span class="progress-circle__percent uppercase text-[10px] font-bold text-[#272728]"
				>{{ value }} de {{ steps.length }}</span
			>

			<svg
				class="progress-circle"
				viewBox="0 0 106 106"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink"
			>
				<g
					id="Page-1"
					stroke="none"
					stroke-width="1"
					fill="none"
					fill-rule="evenodd"
				>
					<g
						id="ProgressBar"
						transform="translate(-17.000000, -17.000000)"
					>
						<circle
							id="Oval"
							stroke="#737576"
							stroke-width="2"
							fill-rule="nonzero"
							cx="70"
							cy="70"
							r="50"
						/>
						<path
							id="Oval-Copy"
							class="progress-circle__path"
							d="M70,120 C97.6142375,120 120,97.6142375 120,70 C120,42.3857625 97.6142375,20 70,20 C42.3857625,20 20,42.3857625 20,70 C20,97.6142375 42.3857625,120 70,120 Z"
							stroke="#138600"
							stroke-width="3.5"
							:stroke-dasharray="circle"
							fill-rule="nonzero"
							transform="translate(70.000000, 70.000000) rotate(-125.000000) translate(-70.000000, -70.000000) "
						/>
					</g>
				</g>
			</svg>
		</div>
		<div class="flex justify-center flex-column gap-0">
			<div
				class="items-center"
				style="display: flex"
			>
				<Icon
					icon="material-symbols:arrow-back-ios-rounded"
					class="w-4 h-4 separator text-[#272728]"
				/>
				<h1 class="text-[#272728] text-base font-bold m-0">
					{{ current?.name || '' }}
				</h1>
			</div>
			<span
				v-if="next"
				class="ml-12"
				>A seguir: {{ next?.name || '' }}</span
			>
		</div>
	</div>
</template>

<script setup>
import { Icon } from '@iconify/vue2'
import { computed, toRefs } from 'vue'

const props = defineProps({
	steps: [Array],
	value: Number,
})

const { steps, value } = toRefs(props)

const percent = computed(() => {
	return (value.value * 100) / steps.value.length
})

const circle = computed(() => {
	return (percent.value / 100) * 100 * Math.PI + ',9999'
})

const current = computed(() => {
	return steps.value.find((step) => step.step === value.value)
})

const next = computed(() => {
	return steps.value.find((step) => step.step === value.value + 1)
})
</script>

<style>
.progress-circle {
	max-width: 60px;
	max-height: 60px;
	width: 100%;
	transform: scaleX(-1) rotate(-55deg);
}

.progress-circle__percent {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

.progress-circle__container {
	display: inline-block;
	position: relative;
}

.progress-circle__path {
	transition: 0.5s ease-in-out all;
}

.container {
	display: flex;
	min-height: 100vh;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}
</style>
